import { combineReducers, createStore, applyMiddleware } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { History } from 'history';
import drawersReducer from './drawers';
import settingsReducer from './settings';
import authReducer from './auth';
import jobsReducer from './jobs';
import groupsReducer from './groups';
import dataExtractionDefinitionsReducer from './dataExtractionDefinitions';
import { ApplicationState } from './types';
import storeContainer from './container';

export const createRootReducer = (history: History) =>
  combineReducers<ApplicationState>({
    drawers: drawersReducer,
    settings: settingsReducer,
    auth: authReducer,
    jobs: jobsReducer,
    groups: groupsReducer,
    dataExtractionDefinitions: dataExtractionDefinitionsReducer,
  });

export const configureStore = (history: History) => {
  const composeEnhancers = composeWithDevTools({ trace: true });

  const storeInstance = createStore(
    createRootReducer(history),
    undefined,
    composeEnhancers(applyMiddleware(routerMiddleware(history), thunk)),
  );

  storeContainer.setStore(storeInstance);

  return storeInstance;
};
